import { AddressArtResponse } from '@/types/service-response'

export class AddressArt {
  public constructor (
    readonly id: number,
    readonly code: string,
    readonly bezeichnung: string
  ) {}

  static createFromResponse (responseData: AddressArtResponse[]): Array<AddressArt> {
    return responseData.map((item: AddressArtResponse ) => {
      return new AddressArt(
        item.ID,
        item.Code,
        item.Bezeichnung
      )
    })
  }
}
